export const SUBSCRIPTION_PERIOD = {
  month: "Monthly",
  year: "Annual",
};

export const SUBSCRIPTION_PERIOD_SHORT = {
  month: "mo",
  year: "yr",
};

export const SUBSCRIPTION_PERIOD_BILLED = {
  month: "monthly",
  year: "annually",
};

export const SUBSCRIPTION_PERIOD_MONTHS = {
  month: 1,
  year: 12,
};

export const getMonthlyPrice = (data: number, months: number) =>
  Math.floor((data / months) * 100) / 100;
